var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg302312313314321Dn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55,
    height: 53,
    viewBox: "0 0 55 53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -2)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009EFF",
    d: "M21.017,45.229 C19.694,47.783 16.675,46.112 17.945,43.647 C19.023,41.552 21.613,40.285 21.613,40.285 C21.613,40.285 22.064,43.201 21.017,45.229 Z M34.306,52.838 C32.983,55.392 29.964,53.721 31.234,51.256 C32.312,49.161 34.902,47.894 34.902,47.894 C34.902,47.894 35.352,50.809 34.306,52.838 Z M24.13,52.838 C22.807,55.392 19.788,53.721 21.058,51.256 C22.136,49.161 24.726,47.894 24.726,47.894 C24.726,47.894 25.176,50.809 24.13,52.838 Z M13.953,52.838 C12.63,55.392 9.611,53.721 10.881,51.256 C11.959,49.161 14.549,47.894 14.549,47.894 C14.549,47.894 15,50.809 13.953,52.838 Z M41.37,45.229 C40.047,47.783 37.028,46.112 38.298,43.647 C39.376,41.552 41.966,40.285 41.966,40.285 C41.966,40.285 42.416,43.201 41.37,45.229 Z M31.193,45.229 C29.87,47.783 26.851,46.112 28.121,43.647 C29.199,41.552 31.789,40.285 31.789,40.285 C31.789,40.285 32.239,43.201 31.193,45.229 Z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    opacity: 0.4,
    transform: "translate(0 -2)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#C9C9C9",
    strokeWidth: 1.4,
    d: "M6.06 29.503L45.192 29.503M11.689 39.708L50.821 39.708M4.561 24.401L43.519 24.401M9.762 34.606L48.72 34.606M6.06 9.093L45.192 9.093M11.689 19.298L50.821 19.298M4.561 3.99L43.519 3.99M10.29 14.16L49.248 14.16M4.561 45.097L43.519 45.097"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg302312313314321Dn);
export default __webpack_public_path__ + "static/media/302_312_313_314_321dn.83ad43a50bdcc215b1cf9aeb3253a351.svg";
export { ForwardRef as ReactComponent };